import React, { useState, useEffect, useRef } from 'react';
import { request } from '@/common/request';
import moment from 'moment';

const myAvatar = require('@/assets/images/common/doctor_male_icon.png');
const aiAvatar = require('@/assets/images/common/ai.png');
const aiLoading = require('@/assets/images/common/ai_loading.gif');

type useChatGptProps = {
  nodeId?: string; // 随访项编号
  formUnionId: string; // 表单union编号
}
export const config = {
  initText: '您好，我是智能AI小助手，你可以问我用药相关问题。',
  finishedText: '好的，非常感谢您的回答，本次随访结束。如果您有其他疑问，可以联系健康管理团队！',
  aiInfo: {
    name: '',
    avatar: aiAvatar,
  },
  selfInfo: {
    name: ' ',
    avatar: myAvatar,
  },
  aiLoading,
  timeout: 1 * 60 * 1000,
};
type msgListItem = {
  message: string; // 消息内容
  name: string; // 发送人名称
  createTime?: string; // 消息发送时间
  avatar?: any; // 头像地址
  isSelf?: boolean; // 是否本人发送的消息
  isError?: boolean; // 消息发送是否异常
  reset?: () => void; // 异常情况重新发送消息
}

export const useChatGpt = (props: useChatGptProps) => {
  const { nodeId, formUnionId } = props;
  const timeOut = useRef<any>(null); // 记录所有定时器，用于销毁时停止所有定时器
  const [msgList, setMsgList] = useState<msgListItem[]>([]);
  const [sessionId, setSessionId] = useState('');
  const [nowSeqNo, setNowSeqNo] = useState(0); // 问题序号，用于判断当前问答是第几题
  const [aiFormConfig, setAiFormConfig] = useState<any>({}); // ai表单配置
  const [loading, setLoading] = useState(false); // 会话应答加载中
  const [isError, setIsError] = useState(false); // 会话是否出错
  const [isFinished, setFinished] = useState(false); // 会话是否结束
  useEffect(() => {
    initChatSession();
    return () => {
      timeOut.current && timeOut.current();
    };
  }, []);
  const initChatSession = () => {
    resetStatus();
    pushMsg({
      message: config.initText,
      createTime: Date.now(),
    });
  };
  const resetStatus = () => {
    setMsgList([]);
    setNowSeqNo(0);
    setAiFormConfig({});
    setLoading(false);
    setIsError(false);
    setFinished(false);
  };
  const pushMsg = (msgData: any, isSelf = false) => {
    setMsgList((v) => {
      const list = [...v];
      const o = isSelf ? config.selfInfo : config.aiInfo;
      list.push({
        ...msgData,
        isSelf,
        ...o,
        createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      });
      return list;
    });
  };
  const sendMessage = (answerText: string) => {
    if (!answerText.trim()) {
      return;
    }
    pushMsg({
      message: answerText,
    }, true);
    setLoading(true);
    request.post('/chat-demo/chat/assistant', {
      question: answerText,
    }).then((res) => {
      setLoading(false);
      pushMsg({
        message: res,
        createTime: Date.now(),
      });
    }).catch(() => {
      setLoading(false);
      pushMsg({
        message: '我没听懂，请你再描述一次。',
        createTime: Date.now(),
      });
    });
    // pushMsg({
    //   message: question,
    //   createTime: res.questionTime,
    // });
  };

  const clearError = (msgItem: any) => {
    setIsError(false);
    // eslint-disable-next-line no-param-reassign
    msgItem.isError = false;
    setMsgList((v) => {
      return [...v];
    });
  };
  const onError = (resetFn: any) => {
    setIsError(true);
    setMsgList((v) => {
      const newMsgList = [...v];
      const msgItem = newMsgList.pop();
      if (msgItem) {
        msgItem.isError = true;
        msgItem.reset = () => {
          clearError(msgItem);
          resetFn();
        };
        newMsgList.push(msgItem);
      }
      return newMsgList;
    });
  };
  return {
    msgList,
    sessionId,
    isFinished,
    isError,
    sendMessage,
    aiFormConfig,
    loading,
  };
};
export default useChatGpt;
